import { useMemo } from "react";
import { useI18nContext } from "@hopper-b2b/i18n";
import { DATE_FORMAT, formatDateTime } from "@hopper-b2b/utilities";
import { useHotelReservationCard as coreUseHotelReservationCard } from "@tenant/hotels";
import dayjs from "dayjs";
import type { HotelReservationCardComponentProps } from "./HotelReservationCard";

export const useHotelReservationCard = (
  props: HotelReservationCardComponentProps
) => {
  const { t } = useI18nContext();

  const { context, handlers, text } = coreUseHotelReservationCard(props);
  const state = props.reservation.state.ReservationState;

  return useMemo(
    () => ({
      context: { ...context, state },
      handlers,
      text: {
        ...text,
        checkInDate: t("trips.tripCard.checkInDate"),
        checkOutDate: t("trips.tripCard.checkOutDate"),
        bookingIdTitle: t("trips.tripCard.bookingId"),
        bookingId: props.reservation.reservationId,
      },
    }),
    [props.reservation, context, handlers, state, t, text]
  );
};
